import { Box, Button, Checkbox, FormControlLabel, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React, { useEffect, useState } from 'react'
import LineInputV3 from '../../../../common/lineInputV3'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import { Item } from '../../../../common/snippets'
import { cellStyles, headerCellStyles } from '../gsReportsConst'
import InfoIcon from '@mui/icons-material/Info';
import DropDownOA from '../../../../common/dropDownOA'
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { clickElement, focusElemnt, isEmpty, navigation1 } from '../../../../common/helper'
import { updateAlertError } from '../../../../../store/common/common_action'
import { connect } from 'react-redux'
import { getGSTValidation, getGSTInvoiceConfigTblData, gstInvoiceConfigUpdate } from '../../../../../store/generalSetting/GSAction'
import Lineinput from '../../../../common/lineinput'
import SuccessAndErrorModal from '../../../../common/SuccessAndErrorModal'
import { useTranslation } from '../../../../../i18n/I18nProvider'

const GstInvoiceCofigPage = (props) => {
  const { translations, language } = useTranslation()
  const cs = translations?.common || {}
  const { updateAlertError, getGSTValidation, getGSTInvoiceConfigTblData, gstInvoiceConfigUpdate, data: { common, generalSettingReducer } } = props
  const { loginData,companySettings } = common;
  const UseToPayAsCOD=companySettings[0]?.UseToPayAsCOD
  const { gstInvoiceConfigData, gstValidationData } = generalSettingReducer
  const gs = translations?.generalSettings || {}
  const tr = (key, fallback) => gs?.[key] || fallback
  const [gstinData, setGstinData] = useState([])
    const [bookingTblData, setBookingTblData] = useState([])
  const [deliveryTblData, setDeliveryTblData] = useState([])
  const [gstNumber, setGstNumber] = useState('')
  const [verified, setVerified] = useState(false)
  const translatedStatusList = [
    { id: 0, name: tr('gsInactive', 'Inactive'), translationKey: 'gsInactive' },
    { id: 1, name: tr('gsActive', 'Active'), translationKey: 'gsActive' },
  ]
  const selectedStatusLabel =
    translatedStatusList.find((item) => item.id === gstinData?.IsEnableConfig)?.name ||
    translatedStatusList[0]?.name
  const [isSuccess, setIsSuccess] = useState(false)
  const modalStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
  useEffect(() => {
    focusElemnt('gicGSTNo')
  }, [])
  useEffect(() => {
    if (!isEmpty(loginData)) {
      let object = {
        CompanyID: loginData?.intCompanyID
      }
      getGSTInvoiceConfigTblData(object)
    }
  }, [loginData])
  useEffect(() => {
    if (!isEmpty(gstInvoiceConfigData)) {
      setGstinData(gstInvoiceConfigData?.Data[0])
      setBookingTblData(gstInvoiceConfigData?.Data1)
      setDeliveryTblData(gstInvoiceConfigData?.Data2)
      setGstNumber(gstInvoiceConfigData?.Data[0]?.GSTN)
    } else {

    }
  }, [gstInvoiceConfigData])
  useEffect(() => {
    if (gstValidationData?.Data?.length > 0 && !isEmpty(gstValidationData?.Data[0])) {
      let newData = gstValidationData?.Data[0]
      setVerified(true)
      setGstinData({
        ...gstinData, LegalName: newData?.CompanyName, TradeName: newData?.Tradename, PanNo: gstNumber.substring(2, 12),
        State: newData?.State, Status: newData?.Status, ConstitutionOfBuisiness: newData?.CompanyType,
        Address: newData?.DoorNo + ', ' + newData?.FloorNo + ', ' + newData?.BuildingName + ', ' + newData?.Street + ', ' + newData?.City + ', ' + newData?.State + ', ' + newData?.Pincode
      })
    }
  }, [gstValidationData])
  const getConcatenatedData = () => {
    let newData = {}
    bookingTblData?.map((item, index) => {
      Object.keys(item).forEach(key => {
        newData[key] = newData[key] === undefined ? item[key] : newData[key] + "^" + item[key]
      });
    })
    deliveryTblData?.map((item, index) => {
      Object.keys(item).forEach(key => {
        newData[key] = newData[key] === undefined ? item[key] : newData[key] + "^" + item[key]
      });
    })
    return newData
  }
  const getGSTINData = () => {
    if (!isEmpty(loginData)) {
      let object = {
        CompanyID: loginData?.intCompanyID
      }
      getGSTInvoiceConfigTblData(object)
    }
  }
  const handleSave = () => {
    let concatData = getConcatenatedData()
    const object = {
      CompanyID: loginData?.intCompanyID,
      GST: gstNumber,
      LegalName: gstinData?.LegalName,
      TradeName: gstinData?.TradeName,
      PanNo: gstinData?.PanNo,
      State: gstinData?.State,
      ConstitutionOfBuisiness: gstinData?.ConstitutionOfBuisiness,
      Status: gstinData?.Status,
      Address: gstinData?.Address,
      MinAmount: gstinData?.MinAmount,
      Rate: gstinData?.GSTRate,
      IsCargoB2B: gstinData?.HasCargoBB,
      IsCargoB2C: gstinData?.HasCargoBC,

      strChargeTypeIDs: concatData?.ChargeTypeID,
      strAtPaidBooking: concatData?.AtPaidBooking,
      strAtPaidManBooking: concatData?.AtPaidManBooking,
      strAtTopayBooking: concatData?.AtTopayBooking,
      strAtTopayManBooking: concatData?.AtTopayManBooking,
      strAtFOCBooking: concatData?.AtFOCBooking,
      strAtSelfBooking: concatData?.AtSelfBooking,
      strAtOnAccBooking: concatData?.AtOnAccBooking,
      strAtCODBooking: concatData?.AtCODBooking,
      strAtDDDVBooking: concatData?.AtDDDVBooking,
      strAtOnAccManBooking: concatData?.AtOnAccManBooking,

      IsConfigEnabled: gstinData?.IsEnableConfig,
      ContactNo: gstinData?.ContactNo,
      EmailID: gstinData?.EmailID,
      DeliveryRate: gstinData?.DeliveryGSTRate,
      BookingHSNCode: gstinData?.BookingHSNCode,
      DeliveryHSNCode: gstinData?.DeliveryHSNCode,
      IsBookingRCM: gstinData?.IsBookingRCMApplicable,
      IsDeliveryRCM: gstinData?.IsDeliveryRCMApplicable,
      IsInforceBookingRCM: gstinData?.IsBookingRCMCompulsory,
      IsInforceDeliveryRCM: gstinData?.IsDelRCMCompulsory
    }
    gstInvoiceConfigUpdate(object).then((res) => {
      if (res?.status == 'Success') {
        setIsSuccess(true)
      } else {
        updateAlertError({ show: true, msg: res.Message, success: false, nextId: 'gicGSTNo' })
      }
    }).catch((err) => {
      console.log("Error:", err)
    })
  }

  const handleChkChange = (e, index, key, tblNo) => {
    if (tblNo === 1) {
      setBookingTblData(prevData => {
        let newData = [...prevData];
        newData[index] = { ...newData[index], [key]: e.target.checked ? 1 : 0 };
        return newData;
      });
    } else {
      setDeliveryTblData(prevData => {
        let newData = [...prevData];
        newData[index] = { ...newData[index], [key]: e.target.checked ? 1 : 0 };
        return newData;
      });

    }
  }
  const handleTblKeyDown = (e, top, bottom, left, right, nextId, prevId, currentId) => {
    if (e.key === ' ') {
      setTimeout(()=>{
        focusElemnt(currentId)
      },1000)
    } else if (e.key === 'ArrowDown') {
      focusElemnt(bottom)
    } else if (e.key === 'ArrowUp') {
      focusElemnt(top)
    } else if (e.key === 'ArrowLeft') {
      focusElemnt(left)
    } else if (e.key === 'ArrowRight') {
      focusElemnt(right)
    } else if (e.key === 'Escape') {
      focusElemnt(prevId)
    } else if (e.key === 'Enter') {
      focusElemnt(nextId)
    }
  }
  const handleKeyDown = (e, siblingId, nextId, prevId, currentId) => {
    if (e.key === ' ') {
      focusElemnt(currentId)
    } else if (e.key === 'ArrowDown') {
      focusElemnt(siblingId)
    } else if (e.key === 'ArrowUp') {
      focusElemnt(siblingId)
    } else if (e.key === 'Escape') {
      focusElemnt(prevId)
    } else if (e.key === 'Enter') {
      focusElemnt(nextId)
    }
  }
  const validateContactNo = (e) => {
    let value = e.target.value;
    if (value === '') {
      return
    } else if (value?.length !== 10) {
      setGstinData({ ...gstinData, ContactNo: '' })
      updateAlertError({ show: true, msg: tr('rpInvalidContact', 'Invalid Contact Number'), nextId: 'gicContactNo' })
    }
  }
  const validateEmail = (e) => {
    let value = e.target.value;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (value === '') {
      return
    } else if (!emailRegex.test(value)) {
      setGstinData({ ...gstinData, EmailID: '' })
      updateAlertError({ show: true, msg: tr('rpInvalidEmail', 'Invalid Email Id'), nextId: 'gicEmailId' })
    }
  }
  const validateGSTRate = (e, key) => {
    let value = e.target.value;
    if (value >= 100 || value === '') {
      setGstinData({ ...gstinData, [key]: '' })
      updateAlertError({ show: true, msg: key === 'GSTRate' ? tr('rpInvalidBkgGstRate', 'Invalid Booking GST Rate') : tr('rpInvalidDelGstRate', 'Invalid Delivery GST Rate'), nextId: key === 'GSTRate' ? 'gicBookingGSTRate' : 'gicDeliveryGSTRate' })
    }
  }
  const validateHSNCode = (e, key) => {
    let value = e.target.value;
    if (value === '' || value?.length > 8) {
      setGstinData({ ...gstinData, [key]: '' })
      updateAlertError({ show: true, msg: key === 'BookingHSNCode' ? tr('rpInvalidBkgHsn', 'Invalid Booking HSN Code') : tr('rpInvalidDelHsn', 'Invalid Delivery HSN Code'), nextId: key === 'BookingHSNCode' ? 'gicBookingHSNCode' : 'gicDeliveryHSNCode' })
    }
  }
  const validateGSTIN = () => {
    if (gstNumber === '' || gstNumber?.length!==15) {
      setGstNumber('')
      updateAlertError({ show: true, msg: tr('rpEnterValidGst', 'Enter Valid GST Number'), nextId:'gicGSTNo' })
    }else{
      const obj = {
        GSTN: gstNumber
      }
      getGSTValidation(obj)
    }
  }
  // const gstNumberValidation = (e) =>{
  //   let value = e.target.value;
  //   if (value === '' || value?.length!==15) {
  //     setGstNumber('')
  //     updateAlertError({ show: true, msg: 'Enter Valid GST Number', nextId:'gicGSTNo' })
  //   }
  // }
  const resetValues = () => {
    if (!isEmpty(loginData)) {
      let object = {
        CompanyID: loginData?.intCompanyID
      }
      getGSTInvoiceConfigTblData(object)
    }
    setVerified(false)
  }
  const GstInvBkngTablRow = (props) => {
    const { index, item, len, tblNo } = props
    return (
      <TableRow key={`Gst-Bkng-Row-${tblNo}-${index}`}>
        <TableCell style={cellStyles}>
          {item.ChargeType}
        </TableCell>
        <TableCell style={{ ...cellStyles, justifyContent: 'center', textAlign: "center" }}>
          <FormControlLabel
            value="end"
            sx={{ marginX: '0px' }}
            control={
              <Checkbox
                id={`paid-${tblNo}-${index}`}
                checked={item.AtPaidBooking === 1}
                onChange={(e) => handleChkChange(e, index, 'AtPaidBooking', tblNo)}
                sx={{ fontSize: '12px', backgroundColor: 'transparent !important', height: '36px', verticalAlign: 'middle' }}
                onKeyDown={(e) =>
                  handleTblKeyDown(e, index === 0 ? `paid-${tblNo}-${index}` : `paid-${tblNo}-${index - 1}`, index === len - 1 ? `paid-${tblNo}-${index}` : `paid-${tblNo}-${index + 1}`,
                    `onAccountManual-${tblNo}-${index}`, `paidManual-${tblNo}-${index}`, index === len - 1 ? `paid-0` : `paid-${tblNo}-${index + 1}`, index === 0 ? tblNo === 1 ? `gicBookingApplicable` : 'gicDeliveryApplicable' : `paid-${tblNo}-${index - 1}`, `paid-${tblNo}-${index}`
                  )}
              />
            }
            labelPlacement="end"
          />
        </TableCell>
        <TableCell style={{ ...cellStyles, justifyContent: 'center', textAlign: "center" }}>
          <FormControlLabel
            value="end"
            sx={{ marginX: '0px' }}
            control={
              <Checkbox
                id={`paidManual-${tblNo}-${index}`}
                checked={item.AtPaidManBooking === 1}
                sx={{ fontSize: '12px', backgroundColor: 'transparent !important', height: '36px', verticalAlign: 'middle' }}
                onChange={(e) => handleChkChange(e, index, 'AtPaidManBooking', tblNo)}
                onKeyDown={(e) =>
                  handleTblKeyDown(e, index === 0 ? `paidManual-${tblNo}-${index}` : `paidManual-${tblNo}-${index - 1}`, index === len - 1 ? `paidManual-${tblNo}-${index}` : `paidManual-${tblNo}-${index + 1}`,
                    `paid-${tblNo}-${index}`, `toPay-${tblNo}-${index}`, index === len - 1 ? `paid-0` : `paid-${tblNo}-${index + 1}`, index === 0 ? `paid-${len - 1}` : `paid-${tblNo}-${index - 1}`, `paidManual-${tblNo}-${index}`
                  )}
              />
            }
            labelPlacement="end"
          />
        </TableCell>
        <TableCell style={{ ...cellStyles, justifyContent: 'center', textAlign: "center" }}>
          <FormControlLabel
            value="end"
            sx={{ marginX: '0px' }}
            control={
              <Checkbox
                id={`toPay-${tblNo}-${index}`}
                checked={item.AtTopayBooking === 1}
                onChange={(e) => handleChkChange(e, index, 'AtTopayBooking', tblNo)}
                sx={{ fontSize: '12px', backgroundColor: 'transparent !important', height: '36px', verticalAlign: 'middle' }}
                onKeyDown={(e) =>
                  handleTblKeyDown(e, index === 0 ? `toPay-${tblNo}-${index}` : `toPay-${tblNo}-${index - 1}`, index === len - 1 ? `toPay-${tblNo}-${index}` : `toPay-${tblNo}-${index + 1}`,
                    `paidManual-${tblNo}-${index}`, `toPayManual-${tblNo}-${index}`, index === len - 1 ? `paid-0` : `paid-${tblNo}-${index + 1}`, index === 0 ? `paid-${len - 1}` : `paid-${tblNo}-${index - 1}`, `toPay-${tblNo}-${index}`
                  )}
              />
            }
            labelPlacement="end"
          />
        </TableCell>
        <TableCell style={{ ...cellStyles, justifyContent: 'center', textAlign: "center" }}>
          <FormControlLabel
            value="end"
            sx={{ marginX: '0px' }}
            control={
              <Checkbox
                id={`toPayManual-${tblNo}-${index}`}
                checked={item.AtTopayManBooking === 1}
                onChange={(e) => handleChkChange(e, index, 'AtTopayManBooking', tblNo)}
                sx={{ fontSize: '12px', backgroundColor: 'transparent !important', height: '36px', verticalAlign: 'middle' }}
                onKeyDown={(e) =>
                  handleTblKeyDown(e, index === 0 ? `toPayManual-${tblNo}-${index}` : `toPayManual-${tblNo}-${index - 1}`, index === len - 1 ? `toPayManual-${tblNo}-${index}` : `toPayManual-${tblNo}-${index + 1}`,
                    `toPay-${tblNo}-${index}`, `foc-${tblNo}-${index}`, index === len - 1 ? `paid-0` : `paid-${tblNo}-${index + 1}`, index === 0 ? `paid-${len - 1}` : `paid-${tblNo}-${index - 1}`, `toPayManual-${tblNo}-${index}`
                  )}
              />
            }
            labelPlacement="end"
          />
          {/* </Item> */}
        </TableCell>
        <TableCell style={{ ...cellStyles, justifyContent: 'center', textAlign: "center" }}>
          <FormControlLabel
            value="end"
            sx={{ marginX: '0px' }}
            control={
              <Checkbox
                id={`foc-${tblNo}-${index}`}
                checked={item.AtFOCBooking === 1}
                onChange={(e) => handleChkChange(e, index, 'AtFOCBooking', tblNo)}
                sx={{ fontSize: '12px', backgroundColor: 'transparent !important', height: '36px', verticalAlign: 'middle' }}
                onKeyDown={(e) =>
                  handleTblKeyDown(e, index === 0 ? `foc-${tblNo}-${index}` : `foc-${tblNo}-${index - 1}`, index === len - 1 ? `foc-${tblNo}-${index}` : `foc-${tblNo}-${index + 1}`,
                    `toPayManual-${tblNo}-${index}`, `self-${tblNo}-${index}`, index === len - 1 ? `paid-0` : `paid-${tblNo}-${index + 1}`, index === 0 ? `paid-${len - 1}` : `paid-${tblNo}-${index - 1}`, `foc-${tblNo}-${index}`
                  )}
              />
            }
            labelPlacement="end"
          />
        </TableCell>
        <TableCell style={{ ...cellStyles, justifyContent: 'center', textAlign: "center" }}>
          <FormControlLabel
            value="end"
            sx={{ marginX: '0px' }}
            control={
              <Checkbox
                id={`self-${tblNo}-${index}`}
                checked={item.AtSelfBooking === 1}
                onChange={(e) => handleChkChange(e, index, 'AtSelfBooking', tblNo)}
                sx={{ fontSize: '12px', backgroundColor: 'transparent !important', height: '36px', verticalAlign: 'middle' }}
                onKeyDown={(e) =>
                  handleTblKeyDown(e, index === 0 ? `self-${tblNo}-${index}` : `self-${tblNo}-${index - 1}`, index === len - 1 ? `self-${tblNo}-${index}` : `self-${tblNo}-${index + 1}`,
                    `foc-${tblNo}-${index}`, `onAccount-${tblNo}-${index}`, index === len - 1 ? `paid-0` : `paid-${tblNo}-${index + 1}`, index === 0 ? `paid-${len - 1}` : `paid-${tblNo}-${index - 1}`, `self-${tblNo}-${index}`
                  )}
              />
            }
            labelPlacement="end"
          />
        </TableCell>
        <TableCell style={{ ...cellStyles, justifyContent: 'center', textAlign: "center" }}>
          <FormControlLabel
            value="end"
            sx={{ marginX: '0px' }}
            control={
              <Checkbox
                id={`onAccount-${tblNo}-${index}`}
                checked={item.AtOnAccBooking === 1}
                onChange={(e) => handleChkChange(e, index, 'AtOnAccBooking', tblNo)}
                sx={{ fontSize: '12px', backgroundColor: 'transparent !important', height: '36px', verticalAlign: 'middle' }}
                onKeyDown={(e) =>
                  handleTblKeyDown(e, index === 0 ? `onAccount-${tblNo}-${index}` : `onAccount-${tblNo}-${index - 1}`, index === len - 1 ? `onAccount-${tblNo}-${index}` : `onAccount-${tblNo}-${index + 1}`,
                    `self-${tblNo}-${index}`, `cod-${tblNo}-${index}`, index === len - 1 ? `paid-0` : `paid-${tblNo}-${index + 1}`, index === 0 ? `paid-${len - 1}` : `paid-${tblNo}-${index - 1}`, `onAccount-${tblNo}-${index}`
                  )}
              />
            }
            labelPlacement="end"
          />
        </TableCell>
        <TableCell style={{ ...cellStyles, justifyContent: 'center', textAlign: "center" }}>
          <FormControlLabel
            value="end"
            sx={{ marginX: '0px' }}
            control={
              <Checkbox
                id={`cod-${tblNo}-${index}`}
                checked={item.AtCODBooking === 1}
                onChange={(e) => handleChkChange(e, index, 'AtCODBooking', tblNo)}
                sx={{ fontSize: '12px', backgroundColor: 'transparent !important', height: '36px', verticalAlign: 'middle' }}
                onKeyDown={(e) =>
                  handleTblKeyDown(e, index === 0 ? `cod-${tblNo}-${index}` : `cod-${tblNo}-${index - 1}`, index === len - 1 ? `cod-${tblNo}-${index}` : `cod-${tblNo}-${index + 1}`,
                    `self-${tblNo}-${index}`, `toPayDDDV-${tblNo}-${index}`, index === len - 1 ? `paid-0` : `paid-${tblNo}-${index + 1}`, index === 0 ? `paid-${len - 1}` : `paid-${tblNo}-${index - 1}`, `cod-${tblNo}-${index}`
                  )}
              />
            }
            labelPlacement="end"
          />
        </TableCell>
        <TableCell style={{ ...cellStyles, justifyContent: 'center', textAlign: "center" }}>
          <FormControlLabel
            value="end"
            sx={{ marginX: '0px' }}
            control={
              <Checkbox
                id={`toPayDDDV-${tblNo}-${index}`}
                checked={item.AtDDDVBooking === 1}
                onChange={(e) => handleChkChange(e, index, 'AtDDDVBooking', tblNo)}
                sx={{ fontSize: '12px', backgroundColor: 'transparent !important', height: '36px', verticalAlign: 'middle' }}
                onKeyDown={(e) =>
                  handleTblKeyDown(e, index === 0 ? `toPayDDDV-${tblNo}-${index}` : `toPayDDDV-${tblNo}-${index - 1}`, index === len - 1 ? `toPayDDDV-${tblNo}-${index}` : `toPayDDDV-${tblNo}-${index + 1}`,
                    `cod-${tblNo}-${index}`, `onAccountManual-${tblNo}-${index}`, index === len - 1 ? `paid-0` : `paid-${tblNo}-${index + 1}`, index === 0 ? `paid-${len - 1}` : `paid-${tblNo}-${index - 1}`, `toPayDDDV-${tblNo}-${index}`
                  )}
              />
            }
            labelPlacement="end"
          />
        </TableCell>
        <TableCell style={{ ...cellStyles, justifyContent: 'center', textAlign: "center" }}>
          <FormControlLabel
            value="end"
            sx={{ marginX: '0px' }}
            control={
              <Checkbox
                id={`onAccountManual-${tblNo}-${index}`}
                checked={item.AtOnAccManBooking === 1}
                onChange={(e) => handleChkChange(e, index, 'AtOnAccManBooking', tblNo)}
                sx={{ fontSize: '12px', backgroundColor: 'transparent !important', height: '36px', verticalAlign: 'middle' }}
                onKeyDown={(e) =>
                  handleTblKeyDown(e, index === 0 ? `onAccountManual-${tblNo}-${index}` : `onAccountManual-${tblNo}-${index - 1}`, index === len - 1 ? `onAccountManual-${tblNo}-${index}` : `onAccountManual-${tblNo}-${index + 1}`,
                    `toPayDDDV-${tblNo}-${index}`, `paid-${tblNo}-${index}`, index === len - 1 ? tblNo === 1 ? `gicDeliveryGSTRate` : 'gicPolicyStatus' : `paid-${tblNo}-${index + 1}`, index === 0 ? `paid-${len - 1}` : `paid-${tblNo}-${index - 1}`, `onAccountManual-${tblNo}-${index}`
                  )}
              />
            }
            labelPlacement="end"
          />
        </TableCell>
      </TableRow>
    )
  }
  const GstBkngTblHeader = ({UseToPayAsCOD}) => {
    return (
      <TableRow key='foc-tbl-header' style={{ background: '#DAEDFE' }}>
        <TableCell style={{ ...headerCellStyles, width: '15%', textAlign: 'left' }} >
          {tr('rpChargesType', 'Charges Type')}
        </TableCell>
        <TableCell style={{ ...headerCellStyles, width: '8%', textAlign: 'center' }} >
          {tr('rpPaid', 'Paid')}
        </TableCell>
        <TableCell style={{ ...headerCellStyles, width: '8%', textAlign: 'center' }} >
          {tr('rpPaidManual', 'Paid Manual')}
        </TableCell>
        <TableCell style={{ ...headerCellStyles, width: '8%', textAlign: 'center' }} >
          {UseToPayAsCOD===1?tr('gsCod', 'COD'):tr('rpTopay', 'Topay')}
        </TableCell>
        <TableCell style={{ ...headerCellStyles, width: '9%', textAlign: 'center' }} >
          {UseToPayAsCOD===1?tr('gsCodManual', 'COD Manual'):tr('rpTopayManual', 'Topay Manual')}
        </TableCell>
        <TableCell style={{ ...headerCellStyles, width: '8%', textAlign: 'center' }} >
          {tr('foc', 'FOC')}
        </TableCell>
        <TableCell style={{ ...headerCellStyles, width: '8%', textAlign: 'center' }} >
          {tr('rpSelf', 'Self')}
        </TableCell>
        <TableCell style={{ ...headerCellStyles, width: '8%', textAlign: 'center' }} >
          {tr('rpOnAccountHyphen', 'On-Account')}
        </TableCell>
        <TableCell style={{ ...headerCellStyles, width: '8%', textAlign: 'center' }} >
          {tr('gsCod', 'COD')}
        </TableCell>
        <TableCell style={{ ...headerCellStyles, width: '8%', textAlign: 'center' }} >
          {UseToPayAsCOD===1?tr('gsCodDddv', 'COD DDDV'):tr('rpTopayDddv', 'Topay DDDV')}
        </TableCell>
        <TableCell style={{ ...headerCellStyles, width: '11%', textAlign: 'center' }} >
          {tr('rpOnAccountManualHyphen', 'On-Account Manual')}
        </TableCell>

      </TableRow>
    )
  }
  return (
    <>
      <Stack className='scrollBlue' style={{ display: 'flex', flexDirection: 'column' }}>
        <Stack style={{ padding: '11px 0px', borderBottom: '1px solid #ddd', display: 'flex', flexDirection: 'row', gap: '15px' }}>
          <Item className="input--wrapper" sx={{ ...sx.itemsx, width: '20%' }}>
            <Lineinput
              id="gicGSTNo"
              onKeyDown={(e) => {
                navigation1(e, 'gicValidateGSTBtn', '')
              }}
              label={tr('rpGstin', 'GSTIN')}
              value={gstNumber || ''}
              onChange={(e) => {setVerified(false);setGstNumber((e.target.value).replaceAll(/[^a-zA-Z0-9]/g, ''))}}
              // onBlur={(e) => gstNumberValidation(e)}
            />
          </Item>
          {verified && <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ color: '#14C508', fontSize: '18px' }}>
              <VerifiedUserIcon style={{ fontSize: '24px' }} />
            </span>
            <span style={{ color: '#14C508', fontSize: '18px', paddingLeft: '5px' }}>
              {tr('rpVerified', 'Verified')}
            </span>
          </div>}
          <Button
            id="gicValidateGSTBtn"
            style={{ margin: '0', height: "40px", minWidth: '100px',padding: '0 12px'  }}
            className="btn add-btn"
            variant="contained"
            color="error"
            onClick={() => validateGSTIN()}
            onKeyDown={(e) => {
              navigation1(e, 'gicContactNo', 'gicGSTNo');
            }}
          >
            {tr('rpValidate', 'validate')}
          </Button>
        </Stack>
        <Stack style={{ padding: '16px 0px 12px 0px', borderBottom: '1px solid #ddd', display: 'flex', flexDirection: 'row', gap: '10px' }}>
          <Item className="input--wrapper" sx={{ ...sx.itemsx, width: '16%' }}>
            <Lineinput
              id='gicLegalBusinessName'
              label={tr('rpLegalName', 'Legal Name of Business')}
              disabled
              value={gstinData?.LegalName || ''}
            />
          </Item>
          <Item className="input--wrapper" sx={{ ...sx.itemsx, width: '19%' }}>
            <Lineinput
              id='gicTradeName'
              label={tr('rpTradeName', 'Trade Name')}
              disabled
              value={gstinData?.TradeName || ''}
            />
          </Item>
          <Item className="input--wrapper" sx={{ ...sx.itemsx, width: '10%' }}>
            <Lineinput
              id='gicPanNo'
              label={tr('rpPanNo', 'Pan No:')}
              disabled
              value={gstinData?.PanNo || ''}
            />
          </Item>
          <Item className="input--wrapper" sx={{ ...sx.itemsx, width: '10%' }}>
            <Lineinput
              id='gicStateName'
              label={tr('rpState', 'State')}
              disabled
              value={gstinData?.State || ''}
            />
          </Item>
          <Item className="input--wrapper" sx={{ ...sx.itemsx, width: '15%' }}>
            <Lineinput
              id='gicConstitutionOfBusiness'
              label={tr('rpConstitution', 'Constitution Of Business')}
              disabled
              value={gstinData?.ConstitutionOfBuisiness || ''}
            />
          </Item>
          <Item className="input--wrapper" sx={{ ...sx.itemsx, width: '15%' }}>
            <Lineinput
              id='gicGST/UINStatus'
              label={tr('rpGstinUinStatus', 'GSTIN / UIN Status')}
              disabled
              value={gstinData?.Status || ''}
            />
          </Item>
          <Item className="input--wrapper" sx={{ ...sx.itemsx, width: '9.8%' }}>
            <Lineinput
              id='gicTaxpayerType'
              label={tr('rpTaxpayerType', 'Taxpayer Type')}
              disabled
            />
          </Item>
        </Stack>
        <Stack style={{ padding: '16px 0px 12px 0px', borderBottom: '1px solid #ddd', display: 'flex', flexDirection: 'row', gap: '10px' }}>
          <Item className="input--wrapper" sx={{ ...sx.itemsx, width: '100%' }}>
            <Lineinput
              id='gicAdminOffice'
              label={tr('rpAdminOffice', 'Administrative Office')}
              disabled
              value={gstinData?.Address || ''}
            />
          </Item>
        </Stack>
        <Stack style={{ padding: '28px 0px 12px 0px', borderBottom: '1px solid #ddd', display: 'flex', flexDirection: 'row', gap: '10px' }}>
          <Item className="input--wrapper" sx={{ ...sx.itemsx, width: '16%' }}>
            <Lineinput
              id='gicContactNo'
              label={tr('rpContactInGst', 'Contact No in GST invoice')}
              value={gstinData?.ContactNo || ''}
              onChange={(e) => setGstinData({ ...gstinData, ContactNo: (e.target.value).replaceAll(/\D/g, '') })}

              onBlur={(e) => validateContactNo(e)}
              onKeyDown={(e) => {
                navigation1(e, 'gicEmailId', 'gicValidateGSTBtn')
              }}
            />
          </Item>
          <Item className="input--wrapper" sx={{ ...sx.itemsx, width: '29%' }}>
            <Lineinput
              id='gicEmailId'
              label={tr('rpEmailInGst', 'Email ID in GST invoice')}
              value={gstinData?.EmailID || ''}
              onChange={(e) => setGstinData({ ...gstinData, EmailID: e.target.value })}
              onBlur={(e) => validateEmail(e)}
              onKeyDown={(e) => {
                navigation1(e, 'gicMinInvAmt', 'gicContactNo')
              }}
            />
          </Item>
          <Item className="input--wrapper" sx={{ ...sx.itemsx, width: '16%' }}>
            <Lineinput
              id='gicMinInvAmt'
              label={tr('rpMinInvoiceAmt', 'Min invoice amount for GST')}
              value={gstinData?.MinAmount || 0}
              textAlign={'right'}
              onChange={(e) => setGstinData({ ...gstinData, MinAmount: (e.target.value).replaceAll(/\D/g, '') })}
              onKeyDown={(e) => {
                navigation1(e, 'gicCargoB2B', 'gicEmailId')
              }}
            />
          </Item>
          <Box sx={{ display: 'flex', flexDirection: 'column', width: '27%', gap: '3px' }}>
            <span style={{ whiteSpace: 'nowrap', fontSize: '14px', fontWeight: '400', color: '#666', paddingLeft: '12px', marginTop: '-23px', maxHeight: '20px' }}>
              {tr('rpGenerateInvoiceFor', 'Generate invoice for:')}</span>
            <Item sx={sx.itemsx} style={{ width: '10%', paddingLeft: '0px', height: "16px" }}>
              <label htmlFor="" style={{ whiteSpace: 'nowrap', fontSize: '14px', fontWeight: '500', color: '#444444' }}>
                <Checkbox
                  id="gicCargoB2B"
                  style={{ paddingLeft: '9px' }}
                  checked={gstinData?.HasCargoBB === 1}
                  onChange={(e) => {
                    setGstinData({ ...gstinData, HasCargoBB: e.target.checked ? 1 : 0 })
                  }}
                  onKeyDown={(e) => {
                    handleKeyDown(e, 'gicCargoB2C', 'gicBookingGSTRate', 'gicMinInvAmt', 'gicCargoB2B')
                  }}
                />
                {tr('rpCargoB2b', 'Cargo B2B (GST is charged and GSTIN is given)')}
              </label>
            </Item>
            <Item sx={sx.itemsx} style={{ width: '10%', paddingLeft: '0px', height: "16px", paddingTop: '8px' }}>
              <label htmlFor="" style={{ whiteSpace: 'nowrap', fontSize: '14px', fontWeight: '500', color: '#444444' }}>
                <Checkbox
                  id="gicCargoB2C"
                  style={{ paddingLeft: '9px' }}
                  checked={gstinData?.HasCargoBC === 1}
                  onChange={(e) => {
                    setGstinData({ ...gstinData, HasCargoBC: e.target.checked ? 1 : 0 })
                  }}
                  onKeyDown={(e) => {
                    handleKeyDown(e, 'gicCargoB2B', 'gicBookingGSTRate', 'gicMinInvAmt', 'gicCargoB2C')
                  }}
                />
                {tr('rpCargoB2c', 'Cargo B2C (GST is charged and GSTIN is not given)')}
              </label>
            </Item>
          </Box>
        </Stack>
        <Stack style={{ padding: '16px 0px 12px 5px', marginTop: '16px', background: '#F5FAFE', display: 'flex', flexDirection: 'row', gap: '10px', borderRadius: '6px' }}>
          <div style={{ fontFamily: 'Roboto', paddingTop: '10px', width: '54%' }}>
            <span style={{ fontWeight: '500', fontSize: '15px', color: '#0086FF' }}>{tr('rpBookingColon', 'BOOKING: ')}</span><span style={{ fontWeight: '500', fontSize: '15px', color: '#444444' }}>{tr('rpGenerateInvoicePayTypes', 'Generate Invoice for following Payment Types with Charges Defined at the Time.')}</span>
          </div>
          <Item className="input--wrapper" sx={{ ...sx.itemsx, width: '14.5%' }}>
            <Lineinput
              id='gicBookingGSTRate'
              label={tr('rpBkgGstRate', 'Booking GST Rate(%)')}
              value={gstinData?.GSTRate || 0}
              textAlign={'right'}
              onChange={(e) => setGstinData({ ...gstinData, GSTRate: (e.target.value).replaceAll(/\D/g, '') })}
              onBlur={(e) => validateGSTRate(e, 'GSTRate')}
              onKeyDown={(e) => {
                navigation1(e, 'gicBookingHSNCode', 'gicCargoB2B')
              }}
            />
          </Item>
          <Item className="input--wrapper" sx={{ ...sx.itemsx, width: '14.5%' }}>
            <Lineinput
              id='gicBookingHSNCode'
              label={tr('rpBkgHsnCode', 'Booking HSN Code')}
              value={gstinData?.BookingHSNCode || ''}
              onChange={(e) => setGstinData({ ...gstinData, BookingHSNCode: (e.target.value).replaceAll(/[^a-zA-Z0-9]/g, '') })}
              onBlur={(e) => validateHSNCode(e, 'BookingHSNCode')}
              onKeyDown={(e) => {
                navigation1(e, 'gicBookingApplicable', 'gicBookingGSTRate')
              }}
            />
          </Item>
          <Box sx={{ display: 'flex', flexDirection: 'column', width: '17%', gap: '3px', paddingLeft: '5px' }}>
            <Item sx={sx.itemsx} style={{ background: '#F5FAFE', paddingLeft: '0px', height: "16px" }}>
              <label htmlFor="" style={{ whiteSpace: 'nowrap', fontSize: '14px', fontWeight: '500', color: '#444444' }}>
                {tr('rpRcmBkgApplicable', 'RCM Booking Applicable')}
                <Checkbox
                  id="gicBookingApplicable"
                  sx={{
                    marginLeft: '19px'
                  }}
                  checked={gstinData?.IsBookingRCMApplicable === 1}
                  onChange={(e) => {
                    setGstinData({ ...gstinData, IsBookingRCMApplicable: e.target.checked ? 1 : 0,IsBookingRCMCompulsory:e.target.checked ? gstinData?.IsBookingRCMCompulsory: 0})
                  }}
                  onKeyDown={(e) => {
                    handleKeyDown(e, 'gicBookingInForce', 'paid-1-0', 'gicBookingHSNCode', 'gicBookingApplicable')
                  }}
                />
              </label>
            </Item>
            <Item sx={sx.itemsx} style={{ background: '#F5FAFE', paddingLeft: '0px', height: "16px", paddingTop: '8px' }}>
              <label htmlFor="" style={{ whiteSpace: 'nowrap', fontSize: '14px', fontWeight: '500', color: '#444444' }}>
                {tr('rpRcmBkgInforce', 'RCM Booking Inforce')}
                <Checkbox
                  id="gicBookingInForce"
                  sx={{ padding: '0', borderRadius: '0', marginLeft: '50px','&.Mui-disabled': {
                    border: 'none !important',
                    backgroundColor: 'transparent !important'
                }}}
                  checked={gstinData?.IsBookingRCMCompulsory === 1}
                  disabled={gstinData?.IsBookingRCMApplicable === 0}
                  onChange={(e) => {
                    setGstinData({ ...gstinData, IsBookingRCMCompulsory: e.target.checked ? 1 : 0 })
                  }}
                  onKeyDown={(e) => {
                    navigation1(e,'paid-1-0', 'gicBookingHSNCode')
                  }}
                />
              </label>
            </Item>
          </Box>
        </Stack>
        <Stack style={{ padding: '16px 0px 16px 0px' }}>
          <TableContainer style={{ border: '1px solid #ddd', borderBottomLeftRadius: '0px', overflow: 'visible' }} component={Paper}>
            <Table style={{ border: "none" }} stickyHeader id="gstConfigTbl" className="table1 table-Received " size="small" aria-label="a dense table">
              <TableHead style={{ position: `sticky`, top: `0`, background: `white`, zIndex: '2' }}>
                <GstBkngTblHeader UseToPayAsCOD={UseToPayAsCOD}/>
              </TableHead>
              {
                bookingTblData?.length > 0 ?
                  <>
                    <TableBody className="filter-data-row" style={{ border: "none" }}>
                      {bookingTblData?.map((item, index) => (
                        <GstInvBkngTablRow item={item} index={index} key={index} len={bookingTblData?.length} tblNo={1} />
                      ))}
                    </TableBody>
                  </> :
                  <>
                  </>
              }
            </Table>
          </TableContainer>
        </Stack>
        <Stack style={{ padding: '16px 0px 12px 5px', background: '#F5FAFE', display: 'flex', flexDirection: 'row', gap: '10px', borderRadius: '6px' }}>
          <div style={{ fontFamily: 'Roboto', fontWight: '500', fontSize: '15px', color: '#444444', paddingTop: '10px', width: '54%', verticalAlign: 'middle' }}>
            <span style={{ fontWeight: '500', fontSize: '15px', color: '#0086FF' }}>{tr('rpDeliveryColon', 'DELIVERY: ')}</span><span style={{ fontWeight: '500', fontSize: '15px', color: '#444444' }}>{tr('rpGenerateInvoicePayTypes', 'Generate Invoice for following Payment Types with Charges Defined at the Time.')}</span>
          </div>
          <Item className="input--wrapper" sx={{ ...sx.itemsx, width: '14.5%' }}>
            <Lineinput
              id='gicDeliveryGSTRate'
              label={tr('rpDelGstRate', 'Delivery GST Rate(%)')}
              value={gstinData?.DeliveryGSTRate || 0}
              textAlign={'right'}
              onChange={(e) => setGstinData({ ...gstinData, DeliveryGSTRate: (e.target.value).replaceAll(/\D/g, '') })}
              onBlur={(e) => validateGSTRate(e, 'DeliveryGSTRate')}
              onKeyDown={(e) => {
                navigation1(e, 'gicDeliveryHSNCode', 'onAccountManual-1-10')
              }}
            />
          </Item>
          <Item className="input--wrapper" sx={{ ...sx.itemsx, width: '14.5%' }}>
            <Lineinput
              id='gicDeliveryHSNCode'
              label={tr('rpDelHsnCode', 'Delivery HSN Code')}
              value={gstinData?.DeliveryHSNCode || ''}
              onChange={(e) => setGstinData({ ...gstinData, DeliveryHSNCode: (e.target.value).replaceAll(/[^a-zA-Z0-9]/g, '') })}
              onBlur={(e) => validateHSNCode(e, 'DeliveryHSNCode')}
              onKeyDown={(e) => {
                navigation1(e, 'gicDeliveryApplicable', 'gicDeliveryGSTRate')
              }}
            />
          </Item>
          <Box sx={{ display: 'flex', flexDirection: 'column', width: '17%', gap: '3px', height: '40px' }}>
            <Item sx={sx.itemsx} style={{ background: '#F5FAFE', paddingLeft: '0px', height: "16px" }}>
              <label htmlFor="" style={{ whiteSpace: 'nowrap', fontSize: '14px', fontWeight: '500', color: '#444444' }}>
                {tr('rpRcmDelApplicable', 'RCM Delivery Applicable')}
                <Checkbox
                  id="gicDeliveryApplicable"
                  style={{ marginLeft: '19px' }}
                  checked={gstinData?.IsDeliveryRCMApplicable === 1}
                  onChange={(e) => {
                    setGstinData({ ...gstinData, IsDeliveryRCMApplicable: e.target.checked ? 1 : 0,IsDelRCMCompulsory:e.target.checked ?gstinData?.IsDelRCMCompulsory:0 })
                  }}
                  onKeyDown={(e) => {
                    handleKeyDown(e, 'gicDeliveryInForce', 'paid-2-0', 'gicDeliveryHSNCode', 'gicDeliveryApplicable')
                  }}
                />
              </label>
            </Item>
            <Item sx={sx.itemsx} style={{ background: '#F5FAFE', paddingLeft: '0px', height: "16px", paddingTop: '8px' }}>
              <label htmlFor="" style={{ whiteSpace: 'nowrap', fontSize: '14px', fontWeight: '500', color: '#444444' }}>
                {tr('rpRcmDelInforce', 'RCM Delivery Inforce')}
                <Checkbox
                  id="gicDeliveryInForce"
                  sx={{
                    padding: '0',
                    borderRadius: '0',
                    marginLeft: '50px',
                    '&.Mui-disabled': {
                      border: 'none !important',
                      backgroundColor: 'transparent !important'
                  }
                  }}
                  checked={gstinData?.IsDelRCMCompulsory === 1}
                  disabled={gstinData?.IsDeliveryRCMApplicable === 0}
                  onChange={(e) => {
                    setGstinData({ ...gstinData, IsDelRCMCompulsory: e.target.checked ? 1 : 0 })
                  }}
                  onKeyDown={(e) => {
                    navigation1(e,'paid-2-0', 'gicDeliveryHSNCode')
                  }}
                />
              </label>
            </Item>
        </Box>
        </Stack>
        <Stack style={{ padding: '16px 0px 16px 0px' }}>
          <TableContainer style={{ border: '1px solid #ddd', borderBottomLeftRadius: '0px', overflow: 'visible' }} component={Paper}>
            <Table style={{ border: "none" }} stickyHeader id="gstConfigTblTwo" className="table1 table-Received " size="small" aria-label="a dense table">
              <TableHead style={{ position: `sticky`, top: `0`, background: `white`, zIndex: '2' }}>
                <GstBkngTblHeader UseToPayAsCOD={UseToPayAsCOD}/>
              </TableHead>
              {
                deliveryTblData?.length > 0 ?
                  <>
                    <TableBody className="filter-data-row" style={{ border: "none" }}>
                      {deliveryTblData?.map((item, index) => (
                        <GstInvBkngTablRow item={item} index={index} key={index} len={deliveryTblData?.length} tblNo={2} />
                      ))}
                    </TableBody>
                  </> :
                  <>
                  </>
              }
            </Table>
          </TableContainer>
        </Stack>
        <Stack style={{ padding: '8px 0px 10px 5px', marginBottom: '10px', background: '#F5FAFE', display: 'flex', flexDirection: 'row', gap: '10px', borderRadius: '6px' }}>
          <div style={{ fontSize: '16px', fontFamily: 'Roboto', fontWight: '600', color: '#444444', paddingTop: '10px', width: '24px' }}>
            <span style={{ color: '#0086FF' }}><InfoIcon style={{ fontSize: '20px' }} /> </span></div>

          <div style={{ fontSize: '16px', width: '68%', fontFamily: 'Roboto', fontWight: '600', color: '#444444', paddingTop: '10px' }}>
            <span style={{ color: '#0086FF' }}>{tr('rpGstChargeInfo', 'GST Charge type may differ subject to payment type, based on Service Provider and Service Receiver :')}</span><br />
            <span>{tr('rpGstChargeInfo1', '1. Paid, On-Account : Compare Booking Branch GSTIN and Sender GSTIN to get GST charged type.')}</span><br />
            <span>{tr('rpGstChargeInfo2', '2. ToPay : Compare Delivery Branch GSTIN and Receiver GSTIN to get GST charged type.')}</span><br />
            <span>{tr('rpGstChargeInfo3', '3. In case of RCM Booking/Delivery, GST will be Paid by Service Receiver.')}</span><br />
          </div>
          <div style={{ display: 'flex', fontSize: '16px', fontFamily: 'Roboto', fontWight: '600', color: '#444444', gap: '10px', width: '28%', justifyContent: 'flex-end', paddingTop: '4.6%' }}>
            <Item className={` beachTransBottomSec`} sx={{ paddingTop: '0px', background: '#F5FAFE' }}>
              <DropDownOA
                key={`gicPolicyStatus-${language}-${selectedStatusLabel}`}
                id={'gicPolicyStatus'}
                label={tr('rpPolicyStatus', 'Policy Status')}
                width="100%"
                nextId='gicCncelBtn'
                prevId='onAccountManual-2-3'
                data={translatedStatusList || []}
                defaultvalue={selectedStatusLabel}
                searchPlaceholder={tr('searchStatus', 'Search Status')}
                dataKey={`name`}
                idKey={`id`}
                isError={gstinData?.IsEnableConfig == 0}
                isSuccess={gstinData?.IsEnableConfig == 1}
                onSelResetVal={true}
                onSelect={(val) => {
                  setGstinData({ ...gstinData, IsEnableConfig: val.id })
                }}
              />
            </Item>
            <Button
              id="gicCncelBtn"
              style={{ margin: '0', height: "39px" }}
              className="btn add-btn"
              variant="contained"
              color="error"
              onClick={() => { resetValues() }}
              onKeyDown={(e) => {
                navigation1(e, `gicSaveBtn`, 'gicPolicyStatus');
              }}
            >
              {tr('rpCancelLower', 'cancel')}
            </Button>
            <Button
              id="gicSaveBtn"
              style={{ margin: '0', height: "39px" }}
              className="btn add-btn"
              variant="contained"
              color="error"
              onClick={() => { handleSave() }}
              onKeyDown={(e) => {
                navigation1(e, `gicGSTNo`, 'gicCncelBtn');
              }}
            >
              {tr('rpSaveLower', 'save')}
            </Button>
          </div>
        </Stack>
      </Stack>
      <SuccessAndErrorModal handleClose={() => { setIsSuccess(false); getGSTINData();focusElemnt('gicGSTNo')}} open={isSuccess} title={cs.gstInvoiceConfigurationSavedSuccessfullyNl || 'GST Invoice Configuration\n Saved Successfully!'} modalStyle={modalStyle} />
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateAlertError, getGSTValidation, getGSTInvoiceConfigTblData, gstInvoiceConfigUpdate }
export default connect(mapStateToProps, mapDispatchToProps)(GstInvoiceCofigPage)
